<q9-button-toggle-group [(ngModel)]="selectedTab" (change)="onTabChange()">
  <q9-button-toggle [value]="SUB_TABS.SystemInfoTab">
    {{ 'CORE.SIDEBAR.SYSTEM_INFO_TAB' | translate }}
  </q9-button-toggle>
  <q9-button-toggle [value]="SUB_TABS.ClassificationTab">
    {{ 'CORE.SIDEBAR.CLASSIFICATION_TAB' | translate }}
  </q9-button-toggle>
  <q9-button-toggle *ngIf="isStakeholdersShown()" [value]="SUB_TABS.StakeholdersTab">
    {{ 'CORE.SIDEBAR.STAKEHOLDERS_TAB' | translate }}
    <span class="q9-counter">{{ stakeholdersCount() }}</span>
  </q9-button-toggle>
</q9-button-toggle-group>
<ng-template [cdkPortalOutlet]="tabPortal"></ng-template>
